import localeBr from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CustomHttpInterceptor } from '@core/interceptors/custom-http-Interceptor';
import { environment } from '@environment/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApolloModule } from 'apollo-angular';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fat } from '@fortawesome/pro-thin-svg-icons';





registerLocaleData(localeBr);


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  // preflight do cors do servidor tem q ser false, senão não funciona e dah erros de 404

  return new TranslateHttpLoader(http, `${environment.config.apiUrl}/api/i18n/`, "");
  //return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  //return new CustomTranslateLoader(http); //pode ser usado customloader

}




@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    RouterModule,
    AppRoutingModule,    

    ApolloModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        //useClass:CustomTranslateLoader, //pode ser usado customloader
        deps: [HttpClient]
      }
    }),
    NgxWebstorageModule.forRoot({ prefix: 'iTek', separator: '.', caseSensitive: true }),    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }, // para mat-datepicker
    { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { strict: true } }, // para mat-datepicker
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] }, // para mat-datepicker
    { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS }, // para mat-datepicker
  ],  
  bootstrap: [AppComponent]
})
export class AppModule { 

  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far, fab, fal, fat, fad);
  }
  
}
